var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNadajesipodnadrukIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 49.44 47.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0085c3;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ikony"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.61,33.93H0v-12.57c0-4.53,3.71-8.24,8.24-8.24h32.96c4.53,0,8.24,3.71,8.24,8.24v12.57h-7.61v-10.92H7.61v10.92ZM40.91,17.34c-1.08,0-1.96.88-1.96,1.96s.88,1.96,1.96,1.96,1.96-.88,1.96-1.96-.88-1.96-1.96-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.7,26.1h28.04v21.68H10.7v-21.68ZM17.41,41.59h14.63c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55h-14.63c-.85,0-1.55.69-1.55,1.55s.69,1.55,1.55,1.55ZM17.41,35.38h14.63c.85,0,1.55-.69,1.55-1.55s-.69-1.55-1.55-1.55h-14.63c-.85,0-1.55.69-1.55,1.55s.69,1.55,1.55,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.7,0h28.04v10.03H10.7V0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNadajesipodnadrukIcon);
export default __webpack_public_path__ + "static/media/Nadaje się pod nadruk_icon.c7c407a16a8b7a2d259a2fc682f5bfc4.svg";
export { ForwardRef as ReactComponent };